// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__I7pHc","katex":"Main_katex__GEZg6","CenterFocus":"Main_CenterFocus__AE97o"};